import React, { useState, useEffect } from "react";
import { getPersonalizationInfo } from "./store/actions/personalization";
import { useDispatch, useStore } from "./store";
import { useLocation, useHistory } from "react-router-dom";
import SwitchLocation from "./components/SwitchLocation";
import { AFFORDANCE, logNavigationClicked } from "./util/analytics";
import BookmarksDialog from "./components/BookmarksDialog";
import { FollowedContentDialog } from "./components/FollowedContent";
import ErrorMessage from "./components/ErrorMessage";
import PuaDialog from "./components/PuaDialog";
import LogInMenu from "./components/LogInMenu";
import ErrorBoundary from "./components/ErrorBoundary";
import CollectUserDataDialog from "./components/CollectUserDataDialog";
import MyAccountForSSO from "./components/MyAccountForSSO";
import { useEventBus, EVENT_BUS_EVENTS } from "./util/useEventBus";

function App() {
  const store = useStore();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const eventBus = useEventBus();

  const headerData = store?.personalization?.data?.userHeader;
  const availableProfiles = store?.personalization?.data?.userProfiles || [];
  const { userAttributes } = store?.personalization?.data || {};
  const switchLocationId = "switch-location";
  const myBookmarksId = "my-bookmarks";
  const myFollowedContentId = "my-followed-content";
  const myAccountForSSOId = "my-account-for-sso";
  const puaDialog = headerData?.puaDialog;
  const [isOpen, setIsOpen] = useState(false);
  const [isSwitchModalOpen, setIsSwitchModalOpen] = useState(false);
  const [isBookmarksModalOpen, setIsBookmarksModalOpen] = useState(false);
  const [isFollowedContentModalOpen, setIsFollowedContentModalOpen] = useState(
    false
  );
  const [isMyAccountForSSOModalOpen, setIsMyAccountForSSOModalOpen] = useState(
    false
  );
  const toggleMenu = (e) => {
    setIsOpen(!isOpen);
  };
  const openBookmarksModal = location.state?.openBookmarksModal;
  const { isErrorMsgShown } = store.default;

  useEffect(() => {
    getPersonalizationInfo(dispatch);
    if (openBookmarksModal) {
      setIsBookmarksModalOpen(true);
    }

    return () => {
      const { pathname, search, hash, state } = history.location;
      const rebuiltPath = `${pathname}${search}${hash}`;
      history.replace(rebuiltPath, {
        ...state,
        isFetchBookmarks: false,
      });
    };
  }, [dispatch, history, openBookmarksModal]);

  const clickUserLink = (linkData) => {
    logNavigationClicked({
      affordance: AFFORDANCE.mainMenu,
      navigateTo: linkData.text,
      navigateFrom: null,
    });
    if (linkData.id === myFollowedContentId) {
      setIsFollowedContentModalOpen(true);
    }
    if (linkData.id === switchLocationId) {
      setIsSwitchModalOpen(true);
    }
    if (linkData.id === myBookmarksId) {
      setIsBookmarksModalOpen(true);
    }
    if (linkData.id === myAccountForSSOId) {
      setIsMyAccountForSSOModalOpen(true);
    }
    setIsOpen(false);
  };

  useEffect(() => {
    const handler = () => setIsFollowedContentModalOpen(true);
    eventBus.on(EVENT_BUS_EVENTS.FOLLOWED_CONTENT_MODAL_OPENED, handler);
    return () =>
      eventBus.detach(EVENT_BUS_EVENTS.FOLLOWED_CONTENT_MODAL_OPENED, handler);
  }, [eventBus, setIsFollowedContentModalOpen]);

  //TODO: There is a scope of creating sub components here for triggers and custom links
  //More suitable for refactoring
  return (
    <ErrorBoundary team="cd.ghostriders">
      <div data-testid="user-fragment">
        {headerData && (
          <>
            {userAttributes?.collectUserData && userAttributes?.attributes && (
              <CollectUserDataDialog {...userAttributes} />
            )}
            <LogInMenu
              onMenuItemClick={clickUserLink}
              isOpen={isOpen}
              toggleMenu={toggleMenu}
            />
            {isFollowedContentModalOpen && (
              <FollowedContentDialog
                isOpen={isFollowedContentModalOpen}
                onClose={() => setIsFollowedContentModalOpen(false)}
              />
            )}
            <SwitchLocation
              isOpen={isSwitchModalOpen}
              setIsOpen={setIsSwitchModalOpen}
              availableProfiles={availableProfiles}
            />
            <BookmarksDialog
              isOpen={isBookmarksModalOpen}
              setIsOpen={setIsBookmarksModalOpen}
            />

            {isMyAccountForSSOModalOpen && (
              <MyAccountForSSO
                isOpen={isMyAccountForSSOModalOpen}
                setIsOpen={setIsMyAccountForSSOModalOpen}
                {...userAttributes}
              />
            )}
          </>
        )}
      </div>
      {puaDialog && (
        <PuaDialog puaDialog={puaDialog} linkURLs={headerData?.linkURLs} />
      )}
      <ErrorMessage isErrorMsgShown={isErrorMsgShown} />
    </ErrorBoundary>
  );
}

export default App;
